var OmapiIdConstants = /** @class */ (function () {
    function OmapiIdConstants() {
    }
    OmapiIdConstants.NAME_VOO_SPORT = 'VOO Sport';
    OmapiIdConstants.NAME_STREAMZ = 'Streamz Premium';
    OmapiIdConstants.NAME_STREAMZ_DWN = OmapiIdConstants.NAME_STREAMZ;
    OmapiIdConstants.NAME_STREAMZ_B2B = OmapiIdConstants.NAME_STREAMZ;
    OmapiIdConstants.NAME_STREAMZ_BASIC = 'Streamz Basic';
    OmapiIdConstants.NAME_STREAMZ_BASIC_B2B = 'Streamz Basic Business';
    OmapiIdConstants.NAME_PLAY_MORE = 'Play More';
    OmapiIdConstants.NAME_PLAY_SPORTS = 'Play Sports';
    OmapiIdConstants.NAME_DAY_PASS = 'Day Pass';
    OmapiIdConstants.NAME_RTL_SERIES = 'RTL Series';
    OmapiIdConstants.NAME_BE_TV = 'BE TV';
    OmapiIdConstants.NAME_BE_TV_SPORT = 'BE TV Sport';
    OmapiIdConstants.NAME_OPTION_FR = 'Option Fr';
    OmapiIdConstants.NAME_PASSION_XL = 'Passion XL';
    OmapiIdConstants.NAME_DISCOVER_MORE = 'Discover More';
    OmapiIdConstants.NAME_FAMILY_FUN = 'Family Fun';
    OmapiIdConstants.NAME_BOUQUET_ARABE = 'Bouquet Arabe';
    OmapiIdConstants.NAME_BOUQUET_AFRICAIN = 'Bouquet Africain';
    OmapiIdConstants.NAME_PLAY_TRIAL = 'Streamz Trial';
    OmapiIdConstants.NAME_PLAY_MORE_TRIAL = 'Play More Trial';
    OmapiIdConstants.NAME_PLAY_SPORTS_TRIAL = 'Play Sports Trial';
    OmapiIdConstants.NAME_VRT_NET_GEMIST = 'Vrt Net Gemist';
    OmapiIdConstants.NAME_RED_CARPET_MORE = 'Red Carpet More';
    OmapiIdConstants.NAME_NETFLIX_BASIC_ID = 'Netflix basic';
    OmapiIdConstants.NAME_NETFLIX_STANDARD_ID = 'Netflix standard';
    OmapiIdConstants.NAME_NETFLIX_PREMIUM_ID = 'Netflix premium';
    OmapiIdConstants.NAME_NETFLIX_STANDARD_STREAMZ_ID = 'Netflix + Streamz';
    OmapiIdConstants.NAME_NETFLIX_STANDARD_STREAMZPLUS_ID = 'Netflix + Streamzplus';
    OmapiIdConstants.NAME_NETFLIX_STANDARD_PLAYMORE_ID = 'Netflix + PlayMore';
    OmapiIdConstants.COM_NAME_RED_CARPET_MORE = 'Streamz Premium+';
    OmapiIdConstants.TRIALS = 'trials';
    OmapiIdConstants.NAME_NETFLIX = 'Netflix';
    OmapiIdConstants.NAME_DISNEY_PLUS = 'Disney Plus';
    OmapiIdConstants.NAME_NETFLIX_STANDARD_STREAMZ = 'Netflix + Streamz Premium';
    OmapiIdConstants.NAME_NETFLIX_STANDARD_STREAMZPLUS = 'Netflix + Streamz Premium+';
    OmapiIdConstants.NAME_NETFLIX_STANDARD_PLAYMORE = 'Netflix + Play More';
    OmapiIdConstants.NAME_NETFLIX_STANDALONE_ID = 'Netflix Standalone';
    OmapiIdConstants.PRODUCT_NAME_MAP = new Map([[null, null]]);
    OmapiIdConstants.PRODUCT_TRIAL_MAP = new Map([[null, null]]);
    return OmapiIdConstants;
}());
export { OmapiIdConstants };
